import { ColorSAP } from "../../ontego-ui";
import { styled } from '@mui/material';

const Styled = {};

Styled.SystemMessageList = styled("div")(() => ({
    padding: '12px 16px 12px 16px',
    boxSizing: 'border-box',
    width: "100%",
    display: "inline-flex",
    alignItems: "center",
    height: 65,
    transition: "all .2s ease-in-out",
    cursor: "pointer",
    "&:hover": {
        backgroundColor: ColorSAP.neutral[10]
    }
}));

Styled.SystemMessageContainer = styled("div")(() => ({
    boxSizing: "border-box",
    padding: "32px 40px 32px 40px",
    width: "100%",
    height: 475,
    backgroundColor: ColorSAP.neutral[15],
    borderRadius: 18
}));

Styled.SystemMessageHeaderContainer = styled("div")(() => ({
    display: "flex",
    justifyContent: "space-between"
}));

Styled.SystemMessageListContainer = styled("div")(() => ({
    maxHeight: "calc(100% - 48px)",
    marginTop: "24px",
    overflowY: "scroll"
}));

export default Styled;